import { Module } from "wrapper6";

var $ = jQuery;

export default class DefaultCover extends Module {

    ready(app) {
        this.addEventListeners();        
    }

    addEventListeners() {
        this.changeSlide();
    }

    changeSlide() {
        const LIST = document.querySelectorAll('.mtt-cover-default__repeater-list--item');

        for (let i = 0; i < LIST.length; i++) {
            const ITEM = LIST[i];

            ITEM.addEventListener('click', () => {
                const ID = ITEM.getAttribute('data-id');  
                
                this.changeActiveListItem(ITEM);                
                this.changeSlideText(ID);
                this.changeSlideImage(ID);                
            });                    
        }
    }

    changeActiveListItem(item) {
        document.querySelector('.mtt-cover-default__repeater-list--item.active').classList.remove('active');

        item.classList.add('active');        
    }

    changeSlideText(id) {
        const CORRECT_TEXT = document.querySelector('.mtt-cover-default__repeater-text--wrapper[data-id="'+id+'"]');        

        document.querySelector('.mtt-cover-default__repeater-text--wrapper.active').classList.remove('active');

        CORRECT_TEXT.classList.add('active');            
    }

    changeSlideImage(id) {
        const CORRECT_IMAGE = document.querySelector('.mtt-cover-default__image-wrapper--image[data-id="'+id+'"]');        

        document.querySelector('.mtt-cover-default__image-wrapper--image.active').classList.remove('active');

        CORRECT_IMAGE.classList.add('active');            
    }
}